module.exports = "/_next/static/images/2a0053449bc688a12f5931ab5eb6272d-credit-ric.svg";